import { render, staticRenderFns } from "./SocialMediaUrls.vue?vue&type=template&id=3f228597"
import script from "./SocialMediaUrls.vue?vue&type=script&lang=js"
export * from "./SocialMediaUrls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports